@let data = model();
@let columnData = column();

@switch (columnData.key) {
  @case (getColumnKey('logoUrl')) {
    @if (isNotNil(data.logoUrl)) {
      <app-image-thumbnail>
        <img
          [ngSrc]="data.logoUrl!"
          [fill]="true"
          [alt]="data.logoAlt"
          class="object-contain" />
      </app-image-thumbnail>
    } @else {
      <app-image-thumbnail-unsupported />
    }
  }

  @case (getColumnKey('name')) {
    <div class="flex flex-wrap items-center gap-2">
      <span>{{ data.name }}</span>

      @if (!data.isShown) {
        <span
          class="inline-flex rounded-full bg-rose-50 px-2 py-0.5 text-[0.625rem] font-semibold tracking-[0.08em] text-rose-600 uppercase">
          Nowe
        </span>
      }
    </div>
  }

  @case (getColumnKey('orderNumber')) {
    <div class="flex flex-col gap-2">
      <app-router-link
        [route]="Route.PL_AccountOrderDetails"
        [params]="detailsParams()">
        <div
          pTooltip="Kliknij, aby wyświetlić szczegóły zamówienia"
          class="text-[#3858E9] underline decoration-dotted">
          {{ data.orderNumber }}
        </div>
      </app-router-link>

      @if (data.contextOperations.canBeFilled) {
        <app-router-link
          [route]="Route.PL_AccountQuestionnaireDetails"
          [params]="questionnaireDetailsParams()">
          <div
            class="inline-flex w-fit rounded-full bg-[#dc6b95] px-3 py-1 text-xs font-semibold tracking-[0.08em] text-white uppercase transition hover:bg-[#c95a84]">
            Wypełnij ankietę
          </div>
        </app-router-link>
      }

      @if (data.contextOperations.canBeViewed) {
        <app-router-link
          [route]="Route.PL_AccountQuestionnaireDetails"
          [params]="questionnaireDetailsParams()"
          [queryParams]="previewQueryParams">
          <div
            class="inline-flex w-fit rounded-full border border-[#3858E9] px-3 py-1 text-xs font-semibold tracking-[0.08em] text-[#3858E9] uppercase transition hover:bg-[#eef2ff]">
            Podgląd ankiety
          </div>
        </app-router-link>
      }
    </div>
  }

  @case (getColumnKey('status')) {
    <div class="flex flex-col gap-2">
      <app-box-questionnaire-status [status]="data.status" />

      @if (data.status !== BoxQuestionnaireStatus.Ended) {
        <div class="text-xs text-gray-500">
          Dostępna do {{ data.endDate | date: 'dd.MM.yyyy, HH:mm' }}
        </div>
      }
    </div>
  }

  @default {
    <app-table-body-no-reference-cell [columnKey]="columnData.key" />
  }
}
